module.exports = __webpack_public_path__ + "img/illu-berry.3b3eee43.svg";